function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Colors from "/styles/colors";
import classnames from "classnames";
import { StyledAnimatedTag } from "./animated-tag-component.scss";
const AnimatedTag = (props)=>{
    const { tagToAnimate, tagStartingPosition, onAnimationEndCallback } = props;
    const { tagImg, tagBackgroundColor, tagIndex } = tagToAnimate;
    return /*#__PURE__*/ _jsx(StyledAnimatedTag, {
        className: classnames("animated-tag", "square"),
        style: _object_spread({
            backgroundColor: Colors[tagBackgroundColor]
        }, tagStartingPosition),
        onAnimationEnd: ()=>onAnimationEndCallback(tagIndex)
    });
};
export default AnimatedTag;
